module.exports = __webpack_public_path__ + "static/media/hiring.f27959dd.svg";